export default __webpack_public_path__ + "static/media/product_5.5e1718a3.png";